import { Routes } from '@angular/router';

import { TemplateFormAddComponent } from 'app/apps/template-form-edit/template-form-add.component';
import { TemplateFormEditComponent } from 'app/apps/template-form-edit/template-form-edit.component';
import { TemplateFormsRegisterComponent } from 'app/apps/template-forms/template-forms-register/template-forms-register.component';
import { TemplateFormsTimelineComponent } from 'app/apps/template-forms/template-forms-timeline/template-forms-timeline.component';
import { TemplateFormsWorkflowComponent } from 'app/apps/template-forms/template-forms-workflow/template-forms-workflow.component';
import { TemplateFormsComponent } from 'app/apps/template-forms/template-forms.component';
import { ModuleViews } from 'app/shared/model/module-views.enum';
import { PreventFormClosingService } from 'app/shared/service/prevent-form-closing.service';

export const FORMS_ROUTES: Routes = [
  {
    path: 'forms',
    component: TemplateFormsComponent,
    children: [
      {
        path: 'workflow',
        pathMatch: 'prefix',
        component: TemplateFormsWorkflowComponent,
        data: { view: ModuleViews.Workflow },
        children: [
          {
            path: 'new',
            component: TemplateFormAddComponent,
            canDeactivate: [PreventFormClosingService],
          },
          {
            path: ':formId',
            component: TemplateFormEditComponent,
            canDeactivate: [PreventFormClosingService],
          },
        ],
      },
      {
        path: 'timeline',
        pathMatch: 'prefix',
        component: TemplateFormsTimelineComponent,
        data: { view: ModuleViews.Timeline },
        children: [
          {
            path: 'new',
            component: TemplateFormAddComponent,
            canDeactivate: [PreventFormClosingService],
          },
          {
            path: ':formId',
            component: TemplateFormEditComponent,
            canDeactivate: [PreventFormClosingService],
          },
        ],
      },
      {
        path: 'register',
        pathMatch: 'prefix',
        component: TemplateFormsRegisterComponent,
        data: { view: ModuleViews.Register },
        children: [
          {
            path: 'new',
            component: TemplateFormAddComponent,
            canDeactivate: [PreventFormClosingService],
          },
          {
            path: ':formId',
            component: TemplateFormEditComponent,
            canDeactivate: [PreventFormClosingService],
          },
        ],
      },
      {
        path: 'new',
        component: TemplateFormAddComponent,
        canDeactivate: [PreventFormClosingService],
      },
      {
        path: ':formId',
        component: TemplateFormEditComponent,
        canDeactivate: [PreventFormClosingService],
      },
    ],
  },
  {
    path: '',
    redirectTo: 'forms',
    pathMatch: 'prefix',
  },
];
